module.exports = __webpack_public_path__ + "img/elemento-grafico.aacf3bf0.svg";